<template>
  <div class="container">
    <v-header class="header"></v-header>
    <div class="content">
      <v-sidebar @changeDisplay="setHomeInvisible" :connected="connected" @updateSecondMenu="updateSecondMenu" class="sidebar" :class="{collapse:collapse}" :collapse="collapse"></v-sidebar>
      <div class="view">
        <v-second-menu :menuList="menuList" :currentSide="currentSide" v-show="!isMonitor" class="secondMenu"></v-second-menu>
        <div class="content-wrapper">
          <transition name="move" mode="out-in">
          <keep-alive :exclude="aliveRoute.join(',')">
            <router-view></router-view>
          </keep-alive>
          </transition>
        </div>
      </div>
      <div class="connect" v-if="homeShow">
        <home @enable="changeEnabled()" @changeRouter="changeRouter"></home>
      </div>
    </div>
  </div>
</template>

<script>
import vSidebar from './sidebar'
import vHeader from "./headerBar";
import vSecondMenu from './secondMenu'
import home from './home'
import { mapGetters } from 'vuex'
import { siderBarList, managementMenu, systemMenu, installMenu, settingMenu, testMenu, queryMenu, monitorMenu } from "./menuList.js"
import { getStatList } from "@/api/monitor.js"
export default {
  name: "index",
  components: {
    vSidebar,
    vHeader,
    vSecondMenu,
    home
  },
  created() {
    this.$store.dispatch('init')
  },
  mounted(){
    // 设置初始语言
    this.menuList = this.getMenuList()
    if (this.debugFlag) {
      managementMenu[7].disable = true
    }
    this.currentSide = this.getCurrentSide()
    // 初始化用户信息
    let access_token = localStorage.getItem('access_token');
    this.$store.commit('setToken', access_token);
    this.getStatInit();
    this.gettypeInit();
    if (this.$route.params.tid) {
      this.homeShow = true;
    }
  },
  data () {
    return {
      siderBarList,
      collapse: false,
      menuList: [],
      currentSide: "",
      connected: Boolean(localStorage.getItem('debugFlag')) || false,
      searchForm: {
        controllerNo: '',
        loopNo: '',
        startCodeNo: '',
        endCodeNo: ''
      },
      isMonitor: localStorage.getItem('isMonitor') === 'false' ? false : true,
      homeShow: localStorage.getItem('homeShow') === 'false' ? false : true,
      aliveRoute:[],
      // aliveRoute:["annotationInformation","linkageProgramming"]
    }
  },
  watch: {
    $route:{
      // 如果是监控页面则不展示二级菜单，如果不是监控页面则显示二级菜单
      handler(val,oldval){
        console.log(val)
        if (val.name === 'monitor') {
          this.isMonitor = true
          localStorage.setItem('isMonitor', true)
        } else if (val.name === 'index') {
          // 结束连接跳转过来的
          if (val.path === '/index/2') {
            this.connected = false
            this.homeShow = true
            managementMenu[7].disable = false
          } else {
            console.log("开始调试点击")
            this.homeShow = true
            localStorage.setItem('homeShow', this.homeShow)
          }
        } else {
          this.isMonitor = false
          localStorage.setItem('isMonitor', false)
        }
      },
      // 深度观察监听
      deep: true
    },
    bwait(newval) {
      console.log(newval,"bwait")
      // 进入等待连接页面
      if (newval) {
        this.homeShow = true
        managementMenu[7].disable = false
        this.$store.commit("changeTidType","timeStamp");
        sessionStorage.tidType = "timeStamp";
        this.$store.commit("changeDebugStatus",2);
        sessionStorage.debugStatus = 2;
        this.$router.push({ name: 'index', params: { tid: this.debugErrorData.dynamicKeyExpir } })
      } else if (newval !== undefined) {
        // 进入开始调试页面
        this.homeShow = true
        this.$router.push('/index/1')
      }
    },
    startAndStop(val){
      // 不需要禁止点击 注释掉
      // this.setDisabled(!val)
    },
  },
  computed: {
    startAndStop(){
      return this.$store.state.startAndStop
    },
    userAvatar () {
      return this.$store.state.avatarImgPath
    },
    local () {
      return this.$store.state.local
    },
    ...mapGetters([
      'debugErrorData'
    ]),
    debugErrorData(){
      return this.$store.state.debugErrorData
    },
    bwait() {
      return this.debugErrorData.bwait
    },
    debugFlag () {
      return this.$store.state.debugFlag
    },
    debugKey(){
      return this.$store.state.debugKey
    },
    controlAuth(){
      return this.$store.state.controlAuth
    },
    uesrAuth(){
      return this.$store.state.userInfo.authorities
    }
  },
  methods: {
    setDisabled(val){
      for (let i in this.menuList) {
        let item = this.menuList[i];
        item.disable = val
      }
    },
    setHomeInvisible(val) {
      this.homeShow = false
    },
    gettypeInit(){
      getStatList({type: "stat_type"}).then(res => {
        this.$store.commit('setTypeList', res.data);
      });
    },
    getStatInit(){
      getStatList({type: "stat"}).then(res => {
        this.$store.commit('setStatList', res.data);
        let relateData = res.data.filter(v => {
          return v.relate
        })
        this.$store.commit('setrRlateData', relateData);
      });
    },
    changeEnabled(val) {
      this.connected = true
      this.homeShow = false
      this.$store.commit('setSideBarActive', 'monitor')
      localStorage.setItem('sideBarActive', 'monitor')
      localStorage.setItem('homeShow', false)
      localStorage.setItem('debugFlag', true)
      managementMenu[7].disable = true
    },
    changeRouter(){
      let parentItem = this.findAuthPath(this.siderBarList)
      console.log(parentItem,"parentItem")
      if (parentItem.childrenMenu) {
        let childrenItem = this.findAuthPath(parentItem.childrenMenu)
        this.$router.replace(childrenItem.url);
      } else {
        this.$router.replace("/monitor/monitor");
      }
    },
    updateSecondMenu(menuList, currentSide) {
      this.menuList = menuList;
      this.currentSide = currentSide;
    },
    findAuthPath(arr){
      return arr.find(item => item.auth === 'management' ? this.uesrAuth.includes(item.auth) : this.uesrAuth.includes(item.auth) && this.controlAuth.includes(item.auth))
    },
    getMenuList() {
      let url = this.$route.path
      if (url.indexOf('management') >= 0) {
        return managementMenu
      } else if (url.indexOf('system') >= 0) {
        return systemMenu
      } else if (url.indexOf('install') >= 0) {
        return installMenu
      } else if (url.indexOf('setting') >= 0) {
        return settingMenu
      } else if (url.indexOf('test') >= 0) {
        return testMenu
      } else if (url.indexOf('query') >= 0) {
        return queryMenu
      } else if (url.indexOf('monitor') >= 0) {
        return monitorMenu
      } else {
        return managementMenu
      }
    },
    getCurrentSide(){
      let url = this.$route.path
      if (url.indexOf('management') >= 0) {
        return "management"
      } else if (url.indexOf('system') >= 0) {
        return "system"
      } else if (url.indexOf('install') >= 0) {
        return "install"
      } else if (url.indexOf('setting') >= 0) {
        return "setting"
      } else if (url.indexOf('test') >= 0) {
        return "test"
      } else if (url.indexOf('query') >= 0) {
        return "query"
      } else if (url.indexOf('monitor') >= 0) {
        return "monitor"
      } else {
        return "management"
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  color: #202d40;
  font-size: 14px;
  overflow: hidden;
  font-family: PingFang SC,Helvetica Neue,Hiragino Sans GB,Segoe UI,Microsoft YaHei,微软雅黑,sans-serif;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  .header{
    padding: 0 20px;
    width: 100%;
    height: 50px;
    font-size: 21px;
    box-sizing: border-box;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    background: #FFFFFF;
    z-index: 100;
    border-bottom: 1px solid rgba(0, 0, 0, 0.16);
  }
  .content{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    box-sizing: border-box;
    overflow-x: hidden;
    .sidebar {
      background-color: #212A3D;
      width: 80px;
      flex: 0 0 80px;
      min-width: 80px;
      max-width: 80px;
      height: 100%;
      box-sizing: border-box;
    }
    .view{
      height: 100%;
      background-color:  #EFF3F9 ;
      display: flex;
      flex: 1;
      flex-direction: row;
      .secondMenu {
        width: 184px;
        height: 100%;
        background-color:  #ffffff;
        box-sizing: border-box;
        flex:0 0 184px;
        overflow: auto;
      }
      .content-wrapper{
        flex: auto;
        padding: 20px;
        overflow: auto;
        height: 100%;
        box-sizing: border-box;
      }
    }
    .connect{
      left: 80px;
      right: 0;
      bottom: 0;
      position: fixed;
      top: 50px;
    }
  }
}

</style>
